<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="650px">
    <div>
      <el-form :inline="true" :model="form" size="small" class="">
        <el-form-item label="名称">
          <el-input v-model="form.title" placeholder="请输入关键字搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>


      <el-table
        :data="tableData"
        style="width: 100%;font-size: 12px;"
        @row-click="onRowClick"
      >
        <el-table-column prop="title" label="商品" width="320">
          <template slot-scope="scope">
            <div class="d-flex">
              <img :src="scope.row.picture + '/H240'" class="product-img"/>
              <div class="ml-10 flex-body" style="width: 220px;">
                <div class="clamp">{{ scope.row.title }}</div>
                <div></div>
                <div class="mt-auto">ID：{{ scope.row.id }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shop_price" label="单价"></el-table-column>
        <el-table-column prop="stock" label="库存"></el-table-column>
        <el-table-column prop="sales" label="销量"></el-table-column>
      </el-table>

      <div class="flex-center-center mt-20"> 
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalItems"
          @current-change="handlePageChage">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      width="960px"
      title="选择SKU"
      :visible.sync="innerVisible"
      append-to-body>
      <div v-if="currentProduct">
        <div class="d-flex">
          <img :src="currentProduct.picture" alt="" class="product-img">
          <div class="flex-body ml-20">
            <div class="mt-10">{{ currentProduct.title }}</div>
            <div class="mt-10">{{ currentProduct.category }}</div>
          </div>
        </div>
        <el-table
          :data="currentProduct.skus || []"
          style="width: 100%"
          @row-click="onSkuClick"
        >
          <el-table-column
            v-for="(item, index) in skuItem"
            :key="index + 's'"
            prop="specs"
            :label="item || '*'"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.specs[item] || '#' }}
            </template>
          </el-table-column>
          <el-table-column prop="market_price" label="京东/天猫价" />
          <el-table-column prop="shop_price" label="零售价" />
          <el-table-column prop="welfare" label="福利券抵扣">
            <template slot-scope="scope">
              {{ Math.ceil(scope.row.welfare) }}
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" />
          <el-table-column prop="code" label="商家编码" />>
        </el-table>
      </div>
      <div v-else class="flex-center-center p-40">
        数据加载中...
      </div>
    </el-dialog>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getProductList, getProduct } from '@/api/product.js';
export default {
  data() {
    return {
      form: {
        title: ''
      },
      currentProduct: null,
      skuItem: [],
      innerVisible: false,
      currentPage: 1,
      pageSize: 5,
      totalItems: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  created() {
    this.loadProductList()
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    async onRowClick(row) {
      this.currentProduct = null
      this.innerVisible = true
      this.currentProduct = await getProduct(row.id)

      let firstSku = this.currentProduct.skus[0] || {};
      this.skuItem = Object.keys(firstSku.specs || {});
    },
    onSkuClick(sku) {
      this.$emit('on-select', this.currentProduct, sku)
      this.innerVisible = false
      this.dialogVisible = false
    },
    // 加载商品细腻些
    async loadProductList(data = {}) {
      let params = Object.assign({
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize
        }, data)
      let { results, count } = await getProductList(params)
      this.totalItems = count
      this.tableData = results
    },
    onSearch() {
      let data = {}
      Object.keys(this.form).forEach(key => {
        if (this.form[key]) data[key] = this.form[key]
      })
      this.currentPage = 1
      this.loadProductList(data)
    },
    // 切换页码
    handlePageChage(v) {
      this.currentPage = v
      this.loadProductList()
    },
    handleClose() {}
  }
}
</script>

<style lang="scss" scoped>
.product-img {
  height: 80px;
  width: 80px;
  border-radius: 7px;
  border: 1px solid #f8f8f8;
}
</style>